import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Icon } from '../display';
import classes from './Accordion.module.scss';

export default function Accordion({
  children,
  className,
  defaultExpanded,
  description,
  title,
  ...rest
}: {
  children: ReactNode;
  className?: string;
  defaultExpanded?: boolean;
  description?: string;
  title: string;
}) {
  return (
    <MuiAccordion
      aria-controls="panel2a-content"
      className={classes.root}
      defaultExpanded={defaultExpanded}
      {...rest}
    >
      <AccordionSummary expandIcon={<Icon icon="chevron-down" />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={clsx(classes.children, className)}>
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
}
